import { create } from 'zustand'

interface TourUiState {
  /** True while the onboarding tour is running. Lets pages (e.g. FormPage's unsaved-changes
   * navigation blocker) treat tour-driven navigation as intentional rather than accidental. */
  isTourActive: boolean
  setTourActive: (active: boolean) => void
  /** Incremented each time the user asks to replay the tour (e.g. via a header button).
   * TourProvider watches this and restarts from step 1 when it changes. */
  restartSignal: number
  requestTourRestart: () => void
}

export const useTourUiStore = create<TourUiState>((set) => ({
  isTourActive: false,
  setTourActive: (active) => set({ isTourActive: active }),
  restartSignal: 0,
  requestTourRestart: () => set((s) => ({ restartSignal: s.restartSignal + 1 })),
}))
